var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCalcutionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_93201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 4.16667C3.33203 3.72464 3.50763 3.30072 3.82019 2.98816C4.13275 2.67559 4.55667 2.5 4.9987 2.5H14.9987C15.4407 2.5 15.8646 2.67559 16.1772 2.98816C16.4898 3.30072 16.6654 3.72464 16.6654 4.16667V15.8333C16.6654 16.2754 16.4898 16.6993 16.1772 17.0118C15.8646 17.3244 15.4407 17.5 14.9987 17.5H4.9987C4.55667 17.5 4.13275 17.3244 3.82019 17.0118C3.50763 16.6993 3.33203 16.2754 3.33203 15.8333V4.16667Z",
    stroke: "#127960",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 6.66536C6.66797 6.44435 6.75577 6.23239 6.91205 6.07611C7.06833 5.91983 7.28029 5.83203 7.5013 5.83203H12.5013C12.7223 5.83203 12.9343 5.91983 13.0906 6.07611C13.2468 6.23239 13.3346 6.44435 13.3346 6.66536V7.4987C13.3346 7.71971 13.2468 7.93167 13.0906 8.08795C12.9343 8.24423 12.7223 8.33203 12.5013 8.33203H7.5013C7.28029 8.33203 7.06833 8.24423 6.91205 8.08795C6.75577 7.93167 6.66797 7.71971 6.66797 7.4987V6.66536Z",
    stroke: "#127960",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 11.668V11.6763",
    stroke: "#127960",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.668V11.6763",
    stroke: "#127960",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 11.668V11.6763",
    stroke: "#127960",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 14.168V14.1763",
    stroke: "#127960",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.168V14.1763",
    stroke: "#127960",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 14.168V14.1763",
    stroke: "#127960",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_93201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalcutionIcon);
export default __webpack_public_path__ + "static/media/greenCalcutionIcon.f11a48aa5f0b69db6783aac7eb909dce.svg";
export { ForwardRef as ReactComponent };